import {
	ADMINADDORUPDATEKYCMAPPING_SUCCESS,
	ADMINADDORUPDATEKYCMAPPING_FAILED,
	RESET_ADMINADDORUPDATEKYCMAPPING,
	LOADING_ADMINADDORUPDATEKYCMAPPING,
	NETWORK_ERROR_ADMINADDORUPDATEKYCMAPPING
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINADDORUPDATEKYCMAPPING:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINADDORUPDATEKYCMAPPING_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINADDORUPDATEKYCMAPPING_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINADDORUPDATEKYCMAPPING:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINADDORUPDATEKYCMAPPING:
			return (state = initialState);
		default:
			return state;
	}
};
